import { rest } from 'msw';
import { getConfig } from 'shared/config';
import { hasEmailSubscription, hasServiceProducts, menuOverview, userProfile } from '.';

const odinAPI = getConfig().odin?.host;

export const handlers = [
  rest.get(`${odinAPI}/yousee/selfcare/userprofile`, (req, res, ctx) => {
    return res(ctx.json(userProfile));
  }),

  rest.get(`${odinAPI}/yousee/selfcare/products/menuoverview`, (req, res, ctx) => {
    return res(ctx.json(menuOverview));
  }),

  rest.get(`${odinAPI}/yousee/selfcare/products/hasserviceproducts`, (req, res, ctx) => {
    return res(ctx.json(hasServiceProducts));
  }),

  rest.get(`${odinAPI}/yousee/selfcare/emails/hassubscription`, (req, res, ctx) => {
    return res(ctx.json(hasEmailSubscription));
  }),
];
